/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AssessmentProposalRequest model module.
 * @module model/AssessmentProposalRequest
 * @version 1.0.0
 */
class AssessmentProposalRequest {
    /**
     * Constructs a new <code>AssessmentProposalRequest</code>.
     * @alias module:model/AssessmentProposalRequest
     * @param proposalPrice {Number} 
     * @param proposalContent {String} 
     * @param tradeType {Number} 
     */
    constructor(proposalPrice, proposalContent, tradeType) { 
        
        AssessmentProposalRequest.initialize(this, proposalPrice, proposalContent, tradeType);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, proposalPrice, proposalContent, tradeType) { 
        obj['proposal_price'] = proposalPrice;
        obj['proposal_content'] = proposalContent;
        obj['trade_type'] = tradeType;
    }

    /**
     * Constructs a <code>AssessmentProposalRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AssessmentProposalRequest} obj Optional instance to populate.
     * @return {module:model/AssessmentProposalRequest} The populated <code>AssessmentProposalRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AssessmentProposalRequest();

            if (data.hasOwnProperty('property_id')) {
                obj['property_id'] = ApiClient.convertToType(data['property_id'], 'Number');
            }
            if (data.hasOwnProperty('proposal_price')) {
                obj['proposal_price'] = ApiClient.convertToType(data['proposal_price'], 'Number');
            }
            if (data.hasOwnProperty('proposal_content')) {
                obj['proposal_content'] = ApiClient.convertToType(data['proposal_content'], 'String');
            }
            if (data.hasOwnProperty('short_appeal_message')) {
                obj['short_appeal_message'] = ApiClient.convertToType(data['short_appeal_message'], 'String');
            }
            if (data.hasOwnProperty('trade_type')) {
                obj['trade_type'] = ApiClient.convertToType(data['trade_type'], 'Number');
            }
            if (data.hasOwnProperty('proposal_date')) {
                obj['proposal_date'] = ApiClient.convertToType(data['proposal_date'], 'String');
            }
            if (data.hasOwnProperty('replace_same_day')) {
                obj['replace_same_day'] = ApiClient.convertToType(data['replace_same_day'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AssessmentProposalRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AssessmentProposalRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AssessmentProposalRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['proposal_content'] && !(typeof data['proposal_content'] === 'string' || data['proposal_content'] instanceof String)) {
            throw new Error("Expected the field `proposal_content` to be a primitive type in the JSON string but got " + data['proposal_content']);
        }
        // ensure the json data is a string
        if (data['short_appeal_message'] && !(typeof data['short_appeal_message'] === 'string' || data['short_appeal_message'] instanceof String)) {
            throw new Error("Expected the field `short_appeal_message` to be a primitive type in the JSON string but got " + data['short_appeal_message']);
        }
        // ensure the json data is a string
        if (data['proposal_date'] && !(typeof data['proposal_date'] === 'string' || data['proposal_date'] instanceof String)) {
            throw new Error("Expected the field `proposal_date` to be a primitive type in the JSON string but got " + data['proposal_date']);
        }

        return true;
    }


}

AssessmentProposalRequest.RequiredProperties = ["proposal_price", "proposal_content", "trade_type"];

/**
 * @member {Number} property_id
 */
AssessmentProposalRequest.prototype['property_id'] = undefined;

/**
 * @member {Number} proposal_price
 */
AssessmentProposalRequest.prototype['proposal_price'] = undefined;

/**
 * @member {String} proposal_content
 */
AssessmentProposalRequest.prototype['proposal_content'] = undefined;

/**
 * @member {String} short_appeal_message
 */
AssessmentProposalRequest.prototype['short_appeal_message'] = undefined;

/**
 * @member {Number} trade_type
 */
AssessmentProposalRequest.prototype['trade_type'] = undefined;

/**
 * 未来日時の場合は予約送信予定日時。未指定または現在以前の場合は即時送信。
 * @member {String} proposal_date
 */
AssessmentProposalRequest.prototype['proposal_date'] = undefined;

/**
 * true かつ proposal_date が未来日時のとき、同一物件宛てで同じ暦日（JST）に入っている送信予約を取り消してから登録する。
 * @member {Boolean} replace_same_day
 * @default false
 */
AssessmentProposalRequest.prototype['replace_same_day'] = false;






export default AssessmentProposalRequest;

